<template>
  <article ref="scrollBox" class="bus_list_wrap">
    <header class="pages_title">
      <div class="myHeader flexContainer">
        <div class="myHeaderL" @click="$router.go(-1);">
          <i class="iconfont_new icon-Left"></i>
        </div>
        <div class="myHeader textalignM">酒店</div>
        <div class="myHeaderR textalignR"></div>
      </div>

      <dropdown-filter :areaList="areaList" :starList="starList" @selectOk="search"></dropdown-filter>
    </header>
    <section class="pages_content">
      <Spin v-if="loading">
        <Icon type="ios-loading" size="18" class="colorprimary demo-spin-icon-load"></Icon>
        <div class="colorprimary">加载中</div>
      </Spin>

      <good-item :list="list" detailPage="HotelDetail"></good-item>
    </section>
  </article>
</template>

<script>
import DropdownFilter from "@/components/child-components/DropdownFilter";
import goodItem from "@/components/child-components/goodItem";
export default {
  name: "HotelList",
  components: {
    DropdownFilter,
    goodItem,
  },
  data() {
    return {
      name: "", // 商户标识

      areaList: [
        { name: "石歧", check: false },
        { name: "东区", check: false },
      ],

      starList: [
        { name: "二钻(星)及以下", text: "经济", check: false },
        { name: "三钻(星)", text: "舒适", check: false },
        { name: "四钻(星)", text: "高档", check: false },
        { name: "五钻(星)", text: "豪华", check: false },
      ],

      loading: false,
      list: [
        {
          id: 1,
          name: "桔子水晶上海虹桥古北路酒店",
          position: "距市中心直线8.2公里",
          star: 4,
          tag: [{ id: 1, value: "商务出行" },{ id: 2, value: "商务出行" },{ id: 3, value: "商务出行" }],
          price: 158,
          warning: "低价房即将售完",
        },
        {
          id: 2,
          name: "桔子水晶上海虹桥古北路酒店",
          position: "距市中心直线8.2公里",
          star: 4,
          tag: [{ id: 1, value: "商务出行" }],
          price: 158,
          warning: "低价房即将售完",
        },
        {
          id: 3,
          name: "桔子水晶上海虹桥古北路酒店",
          position: "距市中心直线8.2公里",
          star: 4,
          tag: [{ id: 1, value: "商务出行" }],
          price: 158,
          warning: "低价房即将售完",
        },
        {
          id: 4,
          name: "桔子水晶上海虹桥古北路酒店",
          position: "距市中心直线8.2公里",
          star: 4,
          tag: [{ id: 1, value: "商务出行" }],
          price: 158,
          warning: "低价房即将售完",
        },
        {
          id: 5,
          name: "桔子水晶上海虹桥古北路酒店",
          position: "距市中心直线8.2公里",
          star: 4,
          tag: [{ id: 1, value: "商务出行" }],
          price: 158,
          warning: "低价房即将售完",
        },
        {
          id: 6,
          name: "桔子水晶上海虹桥古北路酒店",
          position: "距市中心直线8.2公里",
          star: 4,
          tag: [{ id: 1, value: "商务出行" }],
          price: 158,
          warning: "低价房即将售完",
        },
        {
          id: 7,
          name: "桔子水晶上海虹桥古北路酒店",
          position: "距市中心直线8.2公里",
          star: 4,
          tag: [{ id: 1, value: "商务出行" }],
          price: 158,
          warning: "低价房即将售完",
        },
        {
          id: 8,
          name: "桔子水晶上海虹桥古北路酒店",
          position: "距市中心直线8.2公里",
          star: 4,
          tag: [{ id: 1, value: "商务出行" }],
          price: 158,
          warning: "低价房即将售完",
        },
      ],
    };
  },
  activated: function () {},
  created() {},
  mounted() {},
  methods: {
    search(listName,listData) {
      this[listName] = listData
    },
  },
};
</script>

<style scoped lang="less">
@import "../style/home.less";
.pages_title {
  background-color: transparent;
  padding: 0;
  color: #fff;
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/HotelList.vue